import styled from 'styled-components';
import { spacer8, spacer20, screenXsMax, screenSmMin } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "HeaderNav",
  componentId: "z6wcva-0"
})(["@media (max-width:", "){display:none;}@media (min-width:", "){margin-bottom:-", ";margin-top:", ";}"], screenXsMax, screenSmMin, spacer20, spacer8);